import React from "react";
import { Typography } from "@material-ui/core";
import { useTranslation } from "@/langs/useTranslation";
import { BreadCrumbs } from "@/components/device/BreadCrumbs";
import useStyles from "@/styles/groupsStyle";
import ProfileTemplateList from "./ProfileTemplateList";

const TemplateList = () => {
  const { t } = useTranslation();
  const classes = useStyles();

  return (
    <>
      <BreadCrumbs noTranslate pageName={t({ defaultMessage: "配置模板" })} />
      <div className={classes.paperWrapper}>
        <ProfileTemplateList />
      </div>
    </>
  );
};

export default TemplateList;
